const usersRVEOTest = [
  { id: 1, username: "QUISPE MALLQUI, CARMEN", email: "xt8390@rimac.com.pe" },
  { id: 2, username: "VALENZUELA ANCCO, JOSUE", email: "xt7405@rimac.com.pe" },
];

const usersRVEOProd = [
  { id: 1, username: "TALLEDO ORTIZ, RONALD IVAN", email: "rtalledo@rimac.com.pe" },
  { id: 2, username: "HUAROC MONTERO DE QUIJANDRIA, LEDA EDELMIRA", email: "lhuaroc@rimac.com.pe" },
  { id: 3, username: "ALVARADO QUIROZ, MARIA PETRONILA", email: "malvaradoq@rimac.com.pe" },
  { id: 4, username: "SUXE FERNANDEZ, OLGA LIVIA", email: "osuxef@rimac.com.pe" },
  { id: 5, username: "VARGAS QUINTANILLA LOPEZ DE BUSSALLEU, MARISOL", email: "mvargasq@rimac.com.pe" },
  { id: 6, username: "CARRANZA SALAZAR, FERNANDO", email: "fcarranzas@rimac.com.pe" },
  { id: 7, username: "MUÑOZ MASSARO, JUANITA", email: "jmunozm@rimac.com.pe" },
  { id: 8, username: "CHUMACERO GARCIA, RICCI", email: "rchumacerog@rimac.com.pe" },
  { id: 9, username: "RODRIGUEZ CABANILLAS, ADRIANA", email: "hilda.rodriguez@rimac.com.pe" },
  { id: 10, username: "PERALTA NUÑEZ DE LA TORRE, NIVOSKA IRINA", email: "nivoska.peralta@rimac.com.pe" },
  { id: 11, username: "SALAS CARRILLO, YOVANA", email: "yovana.salas@rimac.com.pe" },
  { id: 12, username: "SALAZAR ONETTI, PAOLA JEANETTE", email: "paola.salazar@rimac.com.pe" },
  { id: 13, username: "PUENTE VIDAL, ELIZABETH WILLIANA", email: "elizabeth.puentev@rimac.com.pe" },
  { id: 14, username: "TEJADA SALAS, FLOR DE MARIA", email: "flor.tejada@rimac.com.pe" },
  { id: 15, username: "ARENAS DAMIAN, HEYLI DEL ROSARIO", email: "heyli.arenas@rimac.com.pe" },
  { id: 16, username: "CAMBORDA ALIAGA, LIZ ANDREA", email: "liz.camborda@rimac.com.pe" },
  { id: 17, username: "ESPEJO BAUSCH, MARICELA", email: "maricela.espejobau@rimac.com.pe" },
  { id: 18, username: "SINACAY PINCHE, FRANCESCA", email: "francesca.sinacay@rimac.com.pe" },
  { id: 19, username: "PRADO HEREDIA, KARINA", email: "karina.pradoh@rimac.com.pe" },
  { id: 20, username: "ROSADO OTERO, AYBI SARITA", email: "aybi.rosado@rimac.com.pe" },
  { id: 21, username: "POZO CALLE, MARCO ANTONIO", email: "marco.pozo@rimac.com.pe" },
  { id: 22, username: "ETCHEBARNE ERAZO, KATTY AESMIT", email: "katty.etchebarne@rimac.com.pe" },
  { id: 23, username: "YUCRA MAMANI, YESSICA NINI", email: "yessica.yucra@rimac.com.pe" },
  { id: 24, username: "ORIHUELA GARCIA, HERMINIA ISELA", email: "herminia.orihuela@rimac.com.pe" },
  { id: 25, username: "ARAUCO HANCO, SUSAN NATALY", email: "susan.arauco@rimac.com.pe" },
  { id: 26, username: "CORDOVA JACOVE, SOFIA MELINA", email: "sofia.cordova@rimac.com.pe" },
  { id: 27, username: "GONZALES ZUÑIGA, ANISA RACHIDA", email: "anisa.gonzales@rimac.com.pe" },
  { id: 28, username: "CUZZI LOZA, AIMET MERIT", email: "aimet.cuzzi@rimac.com.pe" },
  { id: 29, username: "GONZALES YONZ, KARLA BETTINA", email: "karla.gonzales@rimac.com.pe" },
  { id: 30, username: "VILLALOBOS FERNANDEZ, ROSA BERTHA", email: "rosa.villalobos@rimac.com.pe" },
  { id: 31, username: "TELLO VIGIL, RAQUEL CECILIA", email: "raquel.tello@rimac.com.pe" },
  { id: 32, username: "CORTEZ TORRES, KEILA GRACIELA", email: "keila.cortez@rimac.com.pe" },
  { id: 33, username: "BEDREGAL RAMOS, EDWIN ALEXANDER", email: "edwin.bedregal@rimac.com.pe" },
  { id: 34, username: "CUADROS OVIEDO, ALVARO GONZALO", email: "alvaro.cuadros@rimac.com.pe" },
  { id: 35, username: "MIRANDA ALFARO, CATHERINE CONSUELO", email: "catherine.miranda@rimac.com.pe" },
  { id: 36, username: "SALGADO FERIA, SOL IMPERIO", email: "sol.salgado@rimac.com.pe" },
  { id: 37, username: "VALVERDE PEREZ, EDUARDO JORGE", email: "eduardo.valverde@rimac.com.pe" },
  { id: 38, username: "ORTEGA GOMERO, ROBERTO EDUARDO", email: "rortegag@rimac.com.pe" },
  { id: 39, username: "TABOADA LANDA, CARLA", email: "carla.taboada@rimac.com.pe" },
];

export const usersRVEO =
  process.env.REACT_APP_AMBIENTE === "TEST"
    ? usersRVEOTest
    : usersRVEOProd;
